module.exports = __webpack_public_path__ + "img/brain-pic.b7d1fde5.png";